import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { ScrollView, Text, RenderHtml } from '@bonanza-social/moonlight';
import {
  selectPrizeWallCampaignName,
  selectPrizeWallCampaignInfoBannerImage,
  selectPrizeWallCampaignTermsAndConditions,
} from '../../state/prizeWallCampaign/prizeWallCampaign.slice';
import { PrizeWallInfoProps } from './PrizeWallInfo.types';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';
import PrizeWallInfoQuickRules from './PrizeWallInfoQuickRules/PrizeWallInfoQuickRules';
import PrizeWallInfoPrizes from './PrizeWallInfoPrizes/PrizeWallInfoPrizes';

function PrizeWallInfo({ children, ...rest }: PrizeWallInfoProps) {
  const [t] = useTranslation('prizeWall');
  const campaignName = useSelector(selectPrizeWallCampaignName);
  const infoBannerImage = useSelector(selectPrizeWallCampaignInfoBannerImage);
  const termsAndConditions = useSelector(
    selectPrizeWallCampaignTermsAndConditions,
  );

  return (
    <ScrollView contentContainerStyle={rest}>
      {children}
      <PrizeWallImage {...infoBannerImage} aspectRatio={1.75} width="100%" />
      <Text
        variant="h4"
        paddingTop="space-400"
        textAlign="center"
        color="darkSurfacePrimary"
      >
        {t('prizeWallInfoCampaignName', { name: campaignName })}
      </Text>
      <PrizeWallInfoQuickRules paddingVertical="space-600" />
      <Text
        variant="body-m"
        locNS="prizeWall"
        locKey="prizeWallInfoTerms"
        color="darkSurfacePrimary"
        paddingBottom="space-200"
      />
      <RenderHtml
        html={termsAndConditions ?? ''}
        variant="body-s"
        color="darkSurfacePrimary"
      />
      <PrizeWallInfoPrizes paddingTop="space-600" />
    </ScrollView>
  );
}

export default memo(PrizeWallInfo);
